export enum ERailSegment {
  FULL_TRAINS = 'Full Trains',
  WAGONS = 'Wagons',
}
